import { Container } from '@/components/ui/Container';
import { BRANDING } from '@/features/marketing/content/branding';
import { HERO_SLIDES } from '@/features/marketing/banners';
import { HeroBannerSlider } from '@/features/marketing/components/HeroBannerSlider';

/**
 * The hero band.
 *
 * The rotation itself is `HeroBannerSlider` with the same `HERO_SLIDES` it has
 * always had - the artwork, its order, where each slide links and the autoplay
 * behaviour are untouched. All this adds is the band around it: the green wash
 * that carries the eye down from the header, and the width, which is the same
 * `Container` the header uses so the banner lines up with the logo above it.
 *
 * The header is `sticky`, not `fixed`, so it takes its own room in the flow and
 * nothing here has to allow for it overlapping.
 */
export function HomeHero() {
  return (
    <section className="bg-linear-to-b from-brand-wash/70 via-brand-tint/50 to-transparent pb-6 pt-4 sm:pb-8 sm:pt-6">
      <Container>
        {/* The slides set their headlines into the artwork, so the page's one
            heading is here for search engines and screen readers. */}
        <h1 className="sr-only">{BRANDING.homeTitle}</h1>
        <HeroBannerSlider slides={HERO_SLIDES} />
      </Container>
    </section>
  );
}
